import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/dividend.svg";
var DividendOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  DividendOutline_default as default
};
